export enum Locales {
  english = "en",
  japanese = "jp",
}
export const LANGUAGES: { [key in Locales]: string } = {
  [Locales.english]: "English",
  [Locales.japanese]: "日本",
};
